import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useContext,
} from "react";
import moment from "moment-timezone";
import ImageViewer from "react-simple-image-viewer";
import "./VirtualSensor.scss";
import { Container, Row, Col } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import DatePicker from "../Calender/DatePicker";
import { useQuery, gql, useLazyQuery, useMutation } from "@apollo/client";
import InputField from "../InputField/InputField";
import { Icon } from "@iconify/react";
import Loader from "react-loader-spinner";
import Messages from "../Messages/Messages";
import ChatInterface from "../Comments/Comments";
import { objectDiff, dateDifference } from "../../helpers/Utils";
import leftArrow from "../../assets/left-arrow.png";
import rightArrow from "../../assets/right-arrow.png";
//import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import { View, StyleSheet } from "react-native";
import CalendarStrip from "react-native-calendar-strip";
import ReactTooltip from "react-tooltip";
import debounce from "lodash.debounce";
import { MyContext } from "../Dashboard/Dashboard.js";
import { InputTextarea } from "primereact/inputtextarea";
import CloseButton from "react-bootstrap/CloseButton";
import useNetwork from "../../customHooks/useNetwork";
import io from "socket.io-client";
import db from "../../DexieDBConfig";
import { Calendar } from "primereact/calendar";
import { uploadOpsFile } from "../Comments/CommentService";
import { getTimeZones } from "@vvo/tzdb";
import ct from "countries-and-timezones";
import { Dropdown } from "primereact/dropdown";
import approval from "../../assets/approval.png";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import warning from "../../assets/warning.svg";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { useLocation } from "react-router-dom";
// import { Agenda } from "react-native-calendars";
let stop = false;
const SENSOR_FETCH = gql`
  query virtualSensorByVesselRoom(
    $vesselId: ID!
    $startTime: Float!
    $endTime: Float!
    $roomId: ID!
    $docType: String!
  ) {
    virtualSensorByVesselRoom(
      vesselId: $vesselId
      startTime: $startTime
      endTime: $endTime
      roomId: $roomId
      docType: $docType
    ) {
      userName
      finishedTime
      correlationId
      sensorData {
        id
        value
        lastSyncedValue
        lastSyncedTime
        approved
      }
    }
  }
`;
const comp_image_query = gql`
  query componentsImage(
    $customerId: ID!
    $roomId: ID!
    $componentId: ID!
    $isMrvEnabled: Boolean!
  ) {
    componentsImage(
      customerId: $customerId
      roomId: $roomId
      componentId: $componentId
      isMrvEnabled: $isMrvEnabled
    )
  }
`;

const virtualSensorDays = gql`
  query virtualSensorDataDays(
    $vesselId: ID!
    $roomId: ID!
    $startDuration: Float!
    $endDuration: Float!
    $docType: String!
  ) {
    virtualSensorDataDays(
      vesselId: $vesselId
      docType: $docType
      virtualSensorDataInput: {
        roomId: $roomId
        startDuration: $startDuration
        endDuration: $endDuration
      }
    )
  }
`;

const componentImageQuery = gql`
  query componentsImage($customerId: ID!, $roomId: ID!, $componentId: ID!) {
    componentsImage(
      customerId: $customerId
      roomId: $roomId
      componentId: $componentId
    )
  }
`;

const sensorFeedTime = gql`
  query manualSensorFeedTime(
    $vesselId: Int!
    $roomId: Int!
    $startTime: Float!
    $endTime: Float!
  ) {
    manualSensorFeedTime(
      vesselId: $vesselId
      roomId: $roomId
      startTime: $startTime
      endTime: $endTime
    )
  }
`;
const genericError = gql`
  query mrvGenericErrors(
  $vesselId: ID!, 
  $logbookDate: Float!
  ) {  
    mrvGenericErrors(
    vesselId: $vesselId,
     logbookDate: $logbookDate
     )
  }
`;

 
const DELETE_SENSOR_FEED_BY_TIME = gql`
  mutation deleteManualSensorFeedByTime(
    $vesselId: Int!
    $roomId: Int!
    $timestamp: Float!
    $docType: String!
    $correlationId: String!
  ) {
    deleteManualSensorFeedByTime(
      vesselId: $vesselId
      roomId: $roomId
      timestamp: $timestamp
      docType: $docType
      correlationId: $correlationId
    )
  }
`;

const getTime = () => {
  const date = new Date();
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return {
    time: strTime,
    weekDay: days[date.getDay()],
    monthDate: date.getDate(),
    month: monthNames[date.getMonth()],
  };
};
var savedFinishTime;
let images = [];
const VirtualSensor = (props) => {
  const [showErrorDetails, setShowErrorDetails] = useState(true);
  let { setBgColor } = useContext(MyContext);
  const debouncedSave = useDebounce(
    (nextValue) => getWeekDates(nextValue),
    500
  );
  const networkState = useNetwork();
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const { online } = networkState;
  const [reloadCalendar, setReloadCalendar] = useState(true);
  const calenderRef = useRef(null);
  //const [trigger, getCommentUnsubmitted] = React.useState(null);
  const { register, handleSubmit, errors, control, setValue } = useForm();
  const [finishedTime, setFinishedTime] = useState();
  const [sensorDetails, setSensorDetails] = useState({});
  const [userName, setUserName] = useState("");
  const [currentTime, setCurrentTime] = useState(getTime());
  const [formData, setFormData] = useState({});
  const [syncedData, setSyncedData] = useState({});
  const [submittedData, setSubmittedData] = useState({});
  const [customDatesStyles, setCustomDatesStyles] = useState([]);
  const [customServerStyles, setCustomServerStyles] = useState([]);
  const [isOnline, setNetwork] = useState(window.navigator.onLine);

  const [prevDateTime, setPrevDateTime] = useState(null);
  const [timePicker, showTimePicker] = useState(false);
  const [enableTime, setEnableTime] = useState(false);
  const [disableField, setDisableField] = useState(false);
  const [selectedDate, setSelectedDate] = useState(moment().format("L"));
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [localDates, setLocalDates] = useState([]);
  const [redDates, setCustomRedDatesStyles] = useState([]);
  const [commentInput, setComment] = useState("");
  const [showCommentsModal, enablePopUp] = useState(false);
  const [calMaxDate, setCalMaxDate] = useState(
    moment(new Date()).add(3, "days")
  );
  const maxDate = moment(new Date());
  const [components, setComponents] = useState([]);
  const [socketData, setSocetMessage] = useState({});
  /*For Upload */
  const [uploadFiles, setUploadFiles] = useState([]);
  const [uploadInprogress, setUploadInprogress] = useState(false);
  /**For Offhire_Reasons Text capture */
  const [offhireHours, setOffHireHours] = useState(null);
  const [docType, setLogbookType] = useState("");
  const [validArrival, setValidArrival] = useState(null);
  const [validDeparture, setValidDeparture] = useState(null);
  const [selectedTZ, setSelectedTZ] = useState(null);
  const [timezones, setTimeZones] = useState([]);
  const [portCodes, setPortCodes] = useState();
  const [viewWarning, setViewWarning] = useState(true);
  const [pastTime, setPastTime] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [validationError, setValidationError] = useState(false);
  const [errorClicked, setErrorClicked] = useState(false);
  const [prevData, setPrevData] = useState(null);
  const [clickevent, setClickEvent] = useState(false);
  const [errorDate, setErrorDate] = useState(null);
  const [VRErrors, setVRErrors] = useState([]);
  const [MRVErrors, setMRVErrors] = useState([]);
  const [timeList, setTimeList] = useState([]);
  const [deleteItem, setDeleteItem] = useState(null);
  const [sensorError, setSensorError] = useState({});
  const [datesBlacklist, setDatesBlacklist] = useState([]);
  const [sketch, setSketch] = useState({});
  const [offset, setOffset] = useState(0);
  const [corelationId, setCorelationId] = useState(null);
  const [backupSensorValues, setBackupSensorValues] = useState({});
  const [offlineBackupValues, setOfflineBackupValues] = useState({});
  const {
    match: { params },
  } = props;
  const { vid, cid, rid } = params;
  const [classSociety, setClassSociety] = useState();
  const [bvRoom, setBvRoom] = useState(false);
  const [isBvDataCompleted, setBvDataCompleted] = useState(false);
  const [fileNames, setFileNames] = useState({});
  const location = useLocation();

  useEffect(() => {
    setSelectedMonth(undefined);
    setSelectedYear(undefined);
    const searchParams = new URLSearchParams(location.search);
    const mrvEnabled = searchParams.get("mrvEnabled");
    const classSocietyParam = searchParams.get("classSociety");
    const dailyRoundParam = searchParams.get("dailyRound");   
    if(mrvEnabled === "true"){
        getVessels();
    }
    if (dailyRoundParam === "true") {
      setBvRoom(false);
      setClassSociety(false);
    } else {
      if (mrvEnabled !== null) {
        setBvRoom(mrvEnabled === "true");
      }
      if (classSocietyParam !== null) {
        setClassSociety(classSocietyParam);
      }
    }
    setBvDataCompleted(true);
  }, [location.search]);

  const virtualSensor_query = gql`
    query componentsVirtualSensorByVesselRoom(
      $vesselId: ID!
      $roomId: ID!
      $customerId: ID!
      $isMrvEnabled: Boolean!
      $classSociety: String
    ) {
      componentsVirtualSensorByVesselRoom(
        vesselId: $vesselId
        roomId: $roomId
        customerId: $customerId
        isMrvEnabled: $isMrvEnabled
        classSociety: $classSociety
      ) {
        name
        id
        code
        Sensor {
          sensorId
          id
          name
          showLastValue
          properties {
            type
            options
            validations
          }
        }
      }
    }
  `;
  const Socket_query = gql`
    query AppConfigData($appCode: String!) {
      appConfigData(appCode: $appCode) {
        socketUrl
      }
    }
  `;

  const [getAppConfigDetails, {}] = useLazyQuery(Socket_query, {
    fetchPolicy: "network-only",
    onCompleted(resp) {
      let url = resp.appConfigData.socketUrl
        ? resp.appConfigData.socketUrl
        : null;
      const socket = io(url, {
        auth: {
          token: localStorage.getItem("access_token"),
        },
        query: {
          vesselId: vid,
          application: btoa(localStorage.getItem("application")),
        },
        transports: ["websocket"],
      });

      socket.on(vid, (data) => {
        setSocetMessage(data);
      });

      return () => {
        socket.disconnect();
      };
    },
  });

  useEffect(() => {
    let difference = dateDifference(selectedDate, moment().format("L"));
    if (difference == 0) {
      if (errorClicked) {
        setEnableTime(true);
        showTimePicker(true);
      }
    }
    if (
      errorClicked &&
      moment(errorDate).format("L") == selectedDate &&
      prevData
    ) {
      if (prevData.online) {
        setFormData({});
        getformData();
        setUploadFiles([]);
        setFileNames({});
      } else {
        // setErrorClicked(false);
        let formData = {};
        db.unsyncedOperations.get(prevData.valueId).then(
          (unSubmittedData) => {
            if (unSubmittedData) {
              setFinishedTime(
                moment(unSubmittedData.UTCtimeStamp).format(
                  "YYYY/MM/DD hh:mm a"
                )
              );
              setUserName(unSubmittedData.user ? unSubmittedData.user : "");
              let date1 = new Date(unSubmittedData.UTCtimeStamp);
              let date2 = new Date(selectedDate);
              let diff = date2.getDate() - date1.getDate();
              if (unSubmittedData && Math.abs(diff) < 1) {
                formData = { ...formData, ...unSubmittedData.value };
                setFormData(formData);
              } else {
                setFormData(formData);
              }
            } else {
              setFormData(formData);
            }
          },
          (err) => {}
        );
        setClickEvent(false);
      }
    }
  }, [errorClicked]);

  useEffect(() => {
    setDatesBlacklist([
      moment().add(1, "days"),
      moment().add(2, "days"),
      moment().add(3, "days"),
      moment().add(4, "days"),
      moment().add(5, "days"),
      moment().add(6, "days"),
      moment().add(7, "days"),
    ]); // 1 day disabled

    const tsz = getTimeZones();

    setTimeZones(tsz);
    let curentTimeZone = new Date().getTimezoneOffset();
    let timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timezoneId =
      ct.getCountryForTimezone(timezoneName) &&
      ct.getCountryForTimezone(timezoneName).id;
    tsz.map((zone) => {
      if (
        timezoneId &&
        zone.group.includes(timezoneName) &&
        zone.countryCode == timezoneId
      ) {
        setSelectedTZ(zone);
      }
      if (timezoneId == null && zone.group.includes(timezoneName)) {
        setSelectedTZ(zone);
      }
    });
    getAppConfigDetails({
      variables: {
        appCode: "OPAPP",
      },
    });

    if (bvRoom) {
      getGenericError();
      if (classSociety == "BV") {
        setLogbookType("mrvbvlogbook");
      } else if (classSociety == "LLOYDS") {
        setLogbookType("mrvlloydslogbook");
      }
    } else {
      setLogbookType("vessellogbook");
    }
    if (bvRoom) {
      let config = JSON.parse(localStorage.getItem("appConfig"));
      db.portCodes.get("ports").then((ports) => {
        if (isOnline) {
          let download =
            ports == undefined || ports.version !== config.locode_version
              ? true
              : false;
          if (download) {
            fetch("/appConfig/portcodes.json", {
              headers: {
                "Content-Type": "application/json",
                "Cache-Control": "no-cache",
                Accept: "application/json",
              },
            })
              .then((res) => res.json())
              .then((data) => {
                db.portCodes.put({
                  key: "ports",
                  version: config.locode_version,
                  data,
                });
                setPortCodes(data);
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            if (ports) {
              setPortCodes(ports.data);
            }
          }
        } else {
          db.portCodes.get("ports").then((ports) => {
            setPortCodes(ports.data);
          });
        }
      });
    }

    db.validationErrors.get(vid).then((results) => {
      if (Object.keys(results).length > 0) {
        let errors = results.data[rid];
        setVRErrors(errors);
      }
    });
    return () => {
      // localStorage.removeItem("mrvRoom");
      // if (localStorage.getItem("voyageRoom")) {
      //   localStorage.removeItem("voyageRoom");
      //   localStorage.removeItem("mrvRoomEnabled");
      // }
    };
  }, [isBvDataCompleted]);

  useEffect(() => {
    //getCommentUnsubmitted();
    return () => {
      window.removeEventListener("offline", updateNetwork);
      window.removeEventListener("online", updateNetwork);
    };
  }, []);

  useEffect(() => {
    if (isBvDataCompleted) {
      fetchData();
    }
  }, [isBvDataCompleted]);

  const fetchData = () => {
    setBgColor("#ffffff");
    window.addEventListener("offline", updateNetwork);
    window.addEventListener("online", updateNetwork);
    setInterval(() => {
      setCurrentTime(getTime());
    }, 60000);
    if (online) {
      getComponents({
        variables: {
          vesselId: vid,
          roomId: rid,
          customerId: cid,
          isMrvEnabled: bvRoom,
          classSociety: classSociety ? classSociety : null,
        },
      });
    } else {
      db.userInfo.toArray().then((users) => {
        let theUser = localStorage.getItem("offline_user_email")
          ? localStorage.getItem("offline_user_email")
          : localStorage.getItem("user_email");
        users.map((user) => {
          if (user.email == theUser) {
            localStorage.setItem("user_name", user.userName);
            user.response.customersByUser.map((cust) => {
              if (cust.customerId == cid) {
                cust.vessels.map((vessel) => {
                  if (vessel.id == vid) {
                    let bvFilterRooms = [];
                    let normalRooms = [];
                    if (bvRoom) {
                      bvFilterRooms = vessel.rooms.filter((room) => {
                        return (
                          room.docType == "mrvbvlogbook" ||
                          room.docType == "mrvlloydslogbook"
                        );
                      });
                    } else {
                      normalRooms = vessel.rooms.filter(
                        (room) => room.docType == "vessellogbook"
                      );
                    }

                    let rooms = bvRoom ? bvFilterRooms : normalRooms;
                    rooms.map((room) => {
                      if (room.id == rid) {
                        let data = {
                          componentsVirtualSensorByVesselRoom: room.components,
                        };
                        data.componentsVirtualSensorByVesselRoom.map((each) => {
                          db.imageStore.toArray().then((images) => {
                            images.map((image) => {
                              if (image.id == `${vid}-${rid}-${each.id}`) {
                                each.image = image.url;
                              }
                            });
                          });
                        });
                        setComponents(data);
                        getformData(data);
                      }
                    });
                  }
                });
              }
            });
          }
        });
      });
    }
  };

  const [getComponents, { loading, error, data }] = useLazyQuery(
    virtualSensor_query,
    {
      fetchPolicy: "network-only",
      onCompleted(resp) {
        getformData();
        let startTime = moment(selectedDate).startOf("day").utc().valueOf();
        let endTime = moment(selectedDate).endOf("day").utc().valueOf();
        let copy = JSON.parse(JSON.stringify(resp));
        copy.componentsVirtualSensorByVesselRoom.map(async (each) => {
          if (!bvRoom) {
            let data = await getCompImage({
              variables: {
                customerId: +cid,
                roomId: +rid,
                componentId: each.id,
                isMrvEnabled: bvRoom,
              },
            })
              .then((data) => {
                each.image = data.data.componentsImage;
              })
              .catch((error) => {
                each.image = "Not Available";
              });
          } else {
            each.image = "Not Available";
          }
          let data1 = await getSensorValues({
            variables: {
              vesselId: vid,
              startTime: startTime,
              endTime: endTime,
              roomId: rid,
              docType:
                bvRoom && classSociety == "BV"
                  ? "mrvbvlogbook"
                  : bvRoom && classSociety == "LLOYDS"
                  ? "mrvlloydslogbook"
                  : "vessellogbook",
            },
          })
            .then((data1) => {
              each.Sensor.map((eachSensor) => {
                data1.data.virtualSensorByVesselRoom.sensorData.map(
                  (eachItem) => {
                    if (eachSensor.id == eachItem.id) {
                      eachSensor.approved = eachItem.approved;
                      if (eachSensor.showLastValue) {
                        eachSensor.lastSyncedValue = eachItem.lastSyncedValue;
                        eachSensor.approved = eachItem.approved;
                        eachSensor.value = eachItem.value;
                        eachSensor.lastSyncedTime = moment(
                          eachItem.lastSyncedTime
                        ).format("YYYY/MM/DD hh:mm a");
                      }
                    }
                    //  else{
                    //   eachSensor.showLastMessage=""
                    //  }

                    // eachSensor.showLastValue=eachItem.showLastValue;
                    // }
                  }
                );
              });
            })
            .catch((error) => {
              each.sensorDetails = {};
            });

          if (each.image !== "Not Available") {
            let image = {
              url: each.image,
              id: `${vid}-${rid}-${each.id}`,
            };
            db.imageStore.add(image, `${vid}-${rid}-${each.id}`);
          }
          let copy2 = JSON.parse(JSON.stringify(copy));
          setComponents(copy2);
        });
        setComponents(copy);
      },
    }
  );

  const openImageViewer = useCallback((index, image) => {
    images[0] = image;
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const [getCompImage, { loadingImg, errorImg, dataImg }] = useLazyQuery(
    comp_image_query,
    {
      fetchPolicy: "cache-and-network",
      onCompleted(data) {
        if (data) {
          return data.componentsImage;
        }
      },
      onError: (error) => {},
    }
  );

  const updateNetwork = () => {
    setNetwork(window.navigator.onLine);
  };

  function useDebounce(callback, delay) {
    const debouncedFn = useCallback(
      debounce((...args) => callback(...args), delay),
      [delay] // will recreate if delay changes
    );
    return debouncedFn;
  }

  const setFiles = (files) => {
    let upf = [...uploadFiles];
    let duplicate = false;
    upf.map((file, i) => {
      if (file.id == files.id) {
        upf[i] = files;
        duplicate = true;
      }
    });
    if (!duplicate) {
      upf.push(files);
    }
    setUploadFiles(upf);
  };

  const cancelCommentAdd = () => {
    enablePopUp(false);
  };
  const Vessel_query = gql`
     query 
     { 
      vesselsByCustomer(id: ${cid})
          {
            id,
            name,
            imo,
            mmsi,
            description,
            imageURL,
            typeDescription,
            displayName,
            contactNumber,
            timezone,
            isMrvEnabled,
            classSociety
          }
    }`;


  const [getVessels, { loadingVessels, errorVessels, dataVessels }] = useLazyQuery(Vessel_query, {
      fetchPolicy: "cache-and-network",
      onCompleted(resp) {
        let vessel = resp.vesselsByCustomer.find((vessel) => vessel.id === parseInt(vid));
        const timezone = vessel.timezone ? vessel.timezone : Intl.DateTimeFormat().resolvedOptions().timeZone;
        const offset = moment.tz(timezone).utcOffset(); // offset in minutes
        setOffset(offset);
      }
    });

  const [getmrvGenericErrors, {}] = useLazyQuery(genericError, {
    fetchPolicy: "network-only",
    onCompleted(resp) {
      if (resp && resp.mrvGenericErrors) {
        setMRVErrors(resp.mrvGenericErrors);
      }
    },
    onError(err) {
      setMRVErrors([]);
    },
  });


  //vessel id
  // const { vid, cid, rid } = params;
  // const { loading, error, data } = useQuery(virtualSensor_query);
  const [getSensorFeedTime, {}] = useLazyQuery(sensorFeedTime, {
    fetchPolicy: "network-only",
    onCompleted(resp) {
      let sensorTime = resp.manualSensorFeedTime
        ? resp.manualSensorFeedTime
        : [];
      sensorTime = sensorTime.map((item) => ({
        time: item,
        online: true,
      }));
      setTimeList((prev) => {
        const merged = [...prev, ...sensorTime];
        merged.sort((a, b) => new Date(a.time) - new Date(b.time));
        return merged;
      });
    },
    onError(err) {
      setTimeList([]);
    },
  });

  const [
    getSensorValues,
    {
      loading: sensorValueLoading,
      error: sensorValueError,
      data: sensorValueData,
    },
  ] = useLazyQuery(SENSOR_FETCH, {
    fetchPolicy: "network-only",
    onCompleted(resp) {
      setUserName("");
      setFinishedTime();
      if (resp && resp.virtualSensorByVesselRoom) {
        let sensorValues = {};
        let approvedFlags = {};
        components.componentsVirtualSensorByVesselRoom.map((each) => {
          each.Sensor.map((eachSensor) => {
            resp.virtualSensorByVesselRoom.sensorData.map((eachItem) => {
              if (eachSensor.id == eachItem.id) {
                eachSensor.approved = eachItem.approved;
                approvedFlags[eachItem.id] = eachItem.approved;
              }
            });
          });
        });
        setUserName(resp.virtualSensorByVesselRoom.userName);

        if (resp.virtualSensorByVesselRoom.finishedTime) {
          setFinishedTime(
            moment(resp.virtualSensorByVesselRoom.finishedTime).format(
              "YYYY/MM/DD hh:mm a"
            )
          );
          setPrevDateTime(
            new Date(resp.virtualSensorByVesselRoom.finishedTime)
          );
        } else {
          setPrevDateTime(new Date(selectedDate));
        }

        setSensorDetails(resp.virtualSensorByVesselRoom.sensorData[0]);
        savedFinishTime = moment(
          resp.virtualSensorByVesselRoom.finishedTime
        ).format("YYYY/MM/DD hh:mm a");
        setCorelationId(resp.virtualSensorByVesselRoom.correlationId);
        resp.virtualSensorByVesselRoom.sensorData.forEach((data) => {
          sensorValues = { ...sensorValues, [data.id]: data.value };
        });
        setBackupSensorValues(sensorValues);
        //update syncdb
        let id = `${vid}-${rid}-${selectedDate}`;
        let data = {
          finishedTime: moment(
            resp.virtualSensorByVesselRoom.finishedTime
          ).format("YYYY/MM/DD hh:mm a"),
          userName: resp.virtualSensorByVesselRoom.userName,
        };
        db.syncedOperations
          .put(
            {
              value: sensorValues,
              UTCtimestamp: resp.virtualSensorByVesselRoom.finishedTime,
              valueId: id,
              finishedTime: data.finishedTime,
              userName: data.userName,
              approvedFlags: approvedFlags,
              corelationId: resp.virtualSensorByVesselRoom.correlationId,
            },
            id
          )
          .then(
            (event) => {
              fetchFromDb();
            },
            (error) => {
              console.log(error);
            }
          );
      } else {
        setCorelationId(null);
        components.componentsVirtualSensorByVesselRoom.map((each) => {
          each.Sensor.map((eachSensor) => {
            eachSensor.approved = false;
          });
        });
        fetchFromDb();
        setPrevDateTime(new Date(selectedDate));
      }
    },
    onError(err) {
      setPrevDateTime(new Date(selectedDate));
      toast.dismiss();
      toast.error(
        "An error occured while getting the saved data. Please reload the app."
      );
    },
  });

  // to populate form fields
  const getformData = async (data = {}) => {
    // check online
    setErrorDate(null);
    setCorelationId(null);
    if (isOnline) {
      //calling graphql query
      let startTime;
      let endTime;
      if (errorClicked && errorDate) {
        // setErrorClicked(false);
        startTime = moment(errorDate).utc().valueOf();
        endTime = moment(errorDate).utc().valueOf();
      } else {
        startTime = moment(selectedDate).startOf("day").utc().valueOf();
        endTime = moment(selectedDate).endOf("day").utc().valueOf();
      }

      const searchParams = new URLSearchParams(location.search);
      const dailyRoundParam = searchParams.get("dailyRound");
      if (dailyRoundParam === "true") {
        setLogbookType("vessellogbook");
      } else {
        if (bvRoom) {
          if (classSociety == "BV") {
            setLogbookType("mrvbvlogbook");
          } else if (classSociety == "LLOYDS") {
            setLogbookType("mrvlloydslogbook");
          }
        } else {
          setLogbookType("vessellogbook");
        }
      }
      try {
        await getSensorValues({
          variables: {
            customerId: cid,
            vesselId: vid,
            startTime: startTime,
            endTime: endTime,
            roomId: rid,
            docType:
              bvRoom && classSociety == "BV"
                ? "mrvbvlogbook"
                : bvRoom && classSociety == "LLOYDS"
                ? "mrvlloydslogbook"
                : "vessellogbook",
          },
        });
      } catch (e) {
        console.log("error fetching sensor");
      }
    } else {
      setPrevDateTime(new Date(selectedDate));
      fetchFromDb(data);
    }
  };

  const getPastTime = () => {
    setPastTime(true);
    offlineFinishedTimes();
  };

 const getGenericError = () => {
  let month = moment(selectedDate).month();
  let year = moment(selectedDate).year();
  let epoch;  
  debugger
  if ((month !== selectedMonth || year !== selectedYear) && (classSociety == "BV" || classSociety == "LLOYDS"))  {
    setSelectedMonth(month);
    setSelectedYear(year); 
    const hardcodedDate = `01/${(month + 1).toString().padStart(2, "0")}/${year}`;
    const jsDate = moment(hardcodedDate, "DD/MM/YYYY").toDate();
    epoch = moment(jsDate)
      .startOf("day")
      .subtract(new Date().getTimezoneOffset(), "minutes")
      .subtract(offset, "minutes")
      .valueOf();
    getmrvGenericErrors({
      variables: {
        vesselId: vid,
         logbookDate: epoch,
      },
    });
  }
  };


  const loadFinishedTimes = () => {
    setTimeList([]);
    if(bvRoom && (classSociety == "BV" || classSociety == "LLOYDS")){
      getGenericError();
    }

    let startTime = moment(selectedDate).startOf("day").utc().valueOf();
    let endTime = moment(selectedDate).endOf("day").utc().valueOf();
    getSensorFeedTime({
      variables: {
        vesselId: +vid,
        roomId: +rid,
        startTime: startTime,
        endTime: endTime,
      },
    });
    offlineFinishedTimes();
  };

  const offlineFinishedTimes = () => {
    db.unsyncedOperations.toArray().then(
      (unSubmittedData) => {
        if (unSubmittedData.length > 0) {
          setTimeList((prev) => {
            const filtered = prev.filter((entry) => entry.online !== false);
            return filtered;
          });
          unSubmittedData.map((item) => {
            let selDate = moment(item.UTCtimeStamp).format("MM/DD/YYYY");
            if (item.VRid == `${vid}-${rid}` && selDate == selectedDate) {
              setFinishedTime(
                moment(item.UTCtimeStamp).format("YYYY/MM/DD hh:mm a")
              );
              let time = {
                time: item.UTCtimeStamp,
                online: false,
                valueId: item.valueId,
              };
              setTimeList((prev) => {
                const updatedList = [...prev, time];
                updatedList.sort((a, b) => new Date(a.time) - new Date(b.time));
                return updatedList;
              });
              setUserName(item.user ? item.user : "");
            }
          });
        }
      },
      (err) => {}
    );
  };
  const fetchFromDb = (data = {}) => {
    let id = `${vid}-${rid}-${selectedDate}`;
    let formData = {};
    db.syncedOperations.get(id).then((syncedData) => {
      if (syncedData) {
        setFinishedTime(
          moment(syncedData.finishedTime).format("YYYY/MM/DD hh:mm a")
        );
        setCorelationId(syncedData.corelationId);
        savedFinishTime = moment(syncedData.finishedTime).format(
          "YYYY/MM/DD hh:mm a"
        );
        data &&
          data.componentsVirtualSensorByVesselRoom &&
          data.componentsVirtualSensorByVesselRoom.map((each) => {
            each.Sensor.map((eachSensor) => {
              eachSensor.approved = syncedData.approvedFlags
                ? syncedData.approvedFlags[eachSensor.id]
                : false;
            });
          });

        setUserName(syncedData.userName);
        setSyncedData(syncedData.value);
        setOfflineBackupValues(syncedData.value);
        formData = { ...formData, ...syncedData.value };
      }
      db.submittedOperations.get(id).then(
        (submittedData) => {
          if (submittedData) {
            setSubmittedData(submittedData.value);
            formData = { ...formData, ...submittedData.value };
          }
          let difference = dateDifference(selectedDate, moment().format("L"));
          // if (difference > 0) {
          //   setFormData(formData);
          // } else {
          db.unsyncedOperations.toArray().then(
            (unSubmittedData) => {
              if (unSubmittedData.length > 0) {
                unSubmittedData.map((item) => {
                  let selDate = moment(item.UTCtimeStamp).format("MM/DD/YYYY");
                  if (item.VRid == `${vid}-${rid}` && selDate == selectedDate) {
                    if (!clickevent) {
                      setFinishedTime(
                        moment(item.UTCtimeStamp).format("YYYY/MM/DD hh:mm a")
                      );
                      setUserName(item.user ? item.user : "");
                      // setFinishedTime(moment(item.UTCtimeStamp).format("YYYY/MM/DD hh:mm a"))
                      setCorelationId(item.corelationId);
                      let data = item;
                      if (data) {
                        let date1 = new Date(data.UTCtimeStamp);
                        let date2 = new Date(selectedDate);
                        let diff = date2.getDate() - date1.getDate();
                        if (data && Math.abs(diff) < 1) {
                          formData = { ...formData, ...data.value };
                          setFormData(formData);
                        } else {
                          setFormData(formData);
                        }
                        setPrevDateTime(new Date(item.UTCtimeStamp));
                      }
                    } else {
                      setFormData(formData);
                    }
                  } else {
                    setFormData(formData);
                  }
                });
              } else {
                setFormData(formData);
              }
              setClickEvent(false);
            },
            (err) => {}
          );
          // }
        },
        (err) => {
          console.log("err", err);
        }
      );
    });
  };

  const clean = (obj) => {
    for (var propName in obj) {
      if (
        obj[propName] === "null" ||
        obj[propName] === null ||
        obj[propName] === "" ||
        obj[propName] === "undefined"
      ) {
        delete obj[propName];
      }
    }
    return obj;
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };
  // form submit to save indexeddb
  const onSubmit = (data) => {
    let fileNameList = fileNames;
    let updatedFileNames;
    if (uploadFiles && uploadFiles.length > 0) {
      updatedFileNames = { ...fileNameList };
      uploadFiles.forEach((file) => {
        if (file.id && updatedFileNames.hasOwnProperty(file.id)) {
          delete updatedFileNames[file.id];
        }
      });
    }else{
      updatedFileNames = { ...fileNameList };
    }
    // converting all values to string
    //  format
    if (sketch && typeof sketch === "object") {
      Object.assign(data, sketch);
    }
    if (bvRoom && validDeparture !== null && validDeparture == false) {
      toast.warning("Port of departure is invalid!");
      return;
    }

    if (bvRoom && validArrival !== null && validArrival == false) {
      toast.warning("Port of arrival is invalid!");
      return;
    }

    Object.keys(data).forEach((key) => {
      data[key] = `${data[key]}`;
      data[key] = data[key].trim();
      // if (offhireHours && offhireHours.name && key == offhireHours.name) {
      //   data[key] = data[key] + " " + `${offhireHours.value} hours`;
      // }
    });

    let gid = `${vid}-${rid}-${moment().utc().valueOf()}`;

    uploadFiles.map((file) => {
      let today = new Date();
      let date = moment(today).format("YYYY/MM/DD");
      let filepathDate = moment.utc(today).format("YYYY/MM/DD");
      let prevDate = moment(prevDateTime).format("YYYY/MM/DD");
      let epoch = moment(today).valueOf();
      if (date !== prevDate) {
        epoch = moment(prevDateTime).valueOf();
        filepathDate = moment.utc(prevDateTime).format("YYYY/MM/DD");
      }
      let filePath =
        filepathDate +
        "/" +
        file.data.fileName +
        "_" +
        epoch +
        "." +
        file.data.format;
      data[file.id] = file.data.fileName + "_" + epoch + "." + file.data.format;
      let id = `${vid}-${rid}-${moment().utc().valueOf()}`;
      if (online) {
        setUploadInprogress(true);
        const formData = new FormData();
        formData.append("file", file.data.onlineFile);
        formData.append("filePath", filePath);
        // if (file.data.docType == "File Upload") {
        //   formData.append("type", "vsensorupload");
        // } else {
        //   formData.append("type", "vsensormrvupload");
        // }
        formData.append("type", file.data.uploadType);
        formData.append("relativeFolderPath", file.data.relativeFolderPath);
        uploadFile(file, gid, formData);
      } else {
        let fileToStore = file;
        fileToStore.id = id;
        fileToStore.gid = gid;
        fileToStore.filePath = filePath;
        db.uploadFiles
          .add(fileToStore, id)
          .then((event) => {})
          .catch((error) => {
            toast.dismiss();
            toast.error(
              `Failed to store ${file.data.fileName}. Please try again.`
            );
          });
      }
    });
    setUploadFiles([]);
    setFileNames({});
    const valueData = clean(data);
    let modifiedData = valueData;
    let correctedSensors = [];
    if (errorClicked) {
      Object.assign(modifiedData, updatedFileNames);    

      let compareSource = online ? backupSensorValues : offlineBackupValues;
      Object.keys(modifiedData).forEach((sensorId) => {
        if (
          compareSource[sensorId] !== undefined &&
          compareSource[sensorId] !== modifiedData[sensorId]
        ) {
          correctedSensors.push(sensorId);
        }
      });
    }

    let date = moment().utc().milliseconds(0).valueOf();

    setUserName(
      localStorage.getItem("user_name") ? localStorage.getItem("user_name") : ""
    );
    let notSameDay =
      moment(date).format("YYYY-MM-DD") ==
      moment(prevDateTime).format("YYYY-MM-DD")
        ? false
        : true;

    if (errorClicked) {
      notSameDay = true;
    }
    let dateCheck = notSameDay ? prevDateTime : date;
    setFinishedTime(
      moment(notSameDay ? prevDateTime : date).format("YYYY/MM/DD hh:mm a")
    );
    if (Object.keys(modifiedData).length !== 0 && moment(dateCheck).isValid()) {
      db.unsyncedOperations.toArray().then((data) => {
        data.map((each) => {
          let timeStamp = notSameDay
            ? Date.parse(prevDateTime)
            : Date.parse(date);
          if (
            each.UTCtimeStamp == errorDate ||
            each.UTCtimeStamp == timeStamp
          ) {
            gid = each.valueId;
          }
        });
      });
      setTimeout(() => {
        db.unsyncedOperations
          .put(
            {
              valueId: gid,
              value: modifiedData,
              correctedSensors: correctedSensors,
              UTCtimeStamp: notSameDay
                ? moment(prevDateTime).utc().milliseconds(0).valueOf()
                : date,
              correctedTime: date,
              timeZoneOffset: selectedTZ
                ? selectedTZ.currentTimeOffsetInMinutes
                : new Date().getTimezoneOffset(),
              Uid: localStorage.getItem("user_uid"),
              VRid: `${vid}-${rid}`,
              user: localStorage.getItem("user_name")
                ? localStorage.getItem("user_name")
                : "",
              type: bvRoom ? "bv" : "",
              classSociety:
                classSociety == "BV"
                  ? "mrvbvlogbook"
                  : classSociety == "LLOYDS"
                  ? "mrvlloydslogbook"
                  : "",
              corelationId: corelationId ? corelationId : null,
            },
            gid
          )
          .then(
            (event) => {
              toast.dismiss();
              toast.success("Finished Successfully!");

              let dots = [...customDatesStyles];
              dots.unshift({
                date: notSameDay
                  ? moment(prevDateTime).utc().milliseconds(0).valueOf()
                  : date,
                dots: [
                  {
                    color: "rgb(93, 229, 253)",
                  },
                ],
              });
              offlineFinishedTimes();
              setCustomDatesStyles(dots);
            },
            (error) => {
              console.log(error);
            }
          );
      }, 1000);
    } else {
      toast.dismiss();
      toast.warning("Nothing to Finish!");
    }
    // }
  };

  const uploadFile = async (file, gid, formData) => {
    try {
      const response = await uploadOpsFile(
        file.data.vid,
        file.data.code,
        formData
      );
      setUploadInprogress(false);
    } catch (error) {
      setUploadInprogress(false);
      let toBeUpdated;
      db.unsyncedOperations.toArray().then((data) => {
        data.map((each) => {
          if (each.valueId == gid) {
            toBeUpdated = each;
            delete toBeUpdated.value[file.id];
            db.unsyncedOperations.put(toBeUpdated, gid);
            toast.error(`${file.value} upload failed. Please try again!`);
          }
        });
      });
    }
  };

  const styles = StyleSheet.create({
    container: { flex: 1 },
  });

  // to clean up on unmount
  useEffect(() => {
    return () => {};
  }, []);

  const clearObject = (obj) => {
    Object.keys(obj).forEach((key) => {
      if (obj[key] == null) {
        delete obj[key];
      }
    });
    return obj;
  };
  const openCommentAdd = () => {
    setComment("");
    enablePopUp(true);
  };
  useEffect(() => {
    loadFinishedTimes();
    // disable prev data
    let difference = dateDifference(selectedDate, moment().format("L"));
    if (difference > 0) {
      setDisableField(false);
      showTimePicker(true);
      setEnableTime(false);
    } else {
      setDisableField(false);
      showTimePicker(false);
      setEnableTime(true);
    }
    setFormData({});
    getformData();
    setUploadFiles([]);
    setFileNames({});
  }, [selectedDate]);

  /* Calendar Color Changes */
  useEffect(() => {
    let custDateStyles = [...customServerStyles];
    let startDate = moment();
    custDateStyles.push({
      startDate: maxDate, // Single date since no endDate provided
      dateNameStyle: { color: "#ffffff", fontSize: 11 },
      dateNumberStyle: { color: "#ffffff", fontSize: 15 },
      dateContainerStyle: {
        backgroundColor: "orange",
      },
    });
    // }
    setCustomServerStyles(custDateStyles);
  }, []);

  const selectedDay = (val) => {
    setSelectedDate(moment(val).format("L"));
    setTimeout(() => {
      stop = false;
    }, 3000);
  };
  let virtualSensorStatus = gql`
  {
    virtualSensorDataDays(
      vesselId: ${vid}
      customerId: ${cid}
      virtualSensorDataInput: {
        roomId: ${rid}
        startDuration: ${startDate}
        endDuration: ${endDate}
      }
    )
  }
`;
  const [getDateStatus, { loading: datesLoading, dateData }] = useLazyQuery(
    virtualSensorDays,
    {
      fetchPolicy: "network-only", // Used for first execution
      // nextFetchPolicy: "cache-first",
      onCompleted(resp) {
        if (resp && resp.virtualSensorDataDays) {
          let dates = resp.virtualSensorDataDays;
          let custDateStyles = [];
          let startDate = moment();
          dates.map((date) => {
            custDateStyles.push({
              date: date,
              dots: [
                {
                  color: "green",
                  // selectedColor: <string> (optional),
                },
              ],
            });
          });
          custDateStyles = [...redDates, ...custDateStyles];
          setCustomDatesStyles(custDateStyles);
        } else {
        }
      },
      onError(err) {
        setCustomDatesStyles([]);
      },
    }
  );

  const getServerDates = async () => {
    if (isOnline) {
      try {
        await getDateStatus({
          variables: {
            vesselId: vid,
            roomId: rid,
            startDuration: startDate,
            endDuration: endDate,
            docType: docType,
          },
        });
      } catch (e) {
        console.log("error fetching sensor");
      }
    }
  };

  useEffect(() => {
    if (endDate) {
      getServerDates();
    }
  }, [endDate]);

  const getWeekDates = (value) => {
    let start = moment(value[0])
      .subtract(1, "day")
      .startOf("day")
      .utc()
      .valueOf();
    let end = moment(value[1]).add(1, "day").endOf("day").utc().valueOf();
    setStartDate(start);
    setEndDate(end);
    setCustomRedDatesStyles([]);

    // let id = `${vid}-${rid}-${selectedDate}`;
    let custDateStyles = [];
    let custDateStylesBlue = [];
    db.submittedOperations.toArray().then(
      (submittedData) => {
        if (submittedData) {
          let dates = [];
          submittedData.map((data) => {
            if (
              data.valueId.indexOf(`${vid}-${rid}`) !== -1 &&
              parseInt(data.UTCtimestamp) >= start &&
              parseInt(data.UTCtimestamp) <= end
            ) {
              dates.push(new Date(parseInt(data.UTCtimestamp)));
            }
          });
          dates = [...new Set(dates)];

          dates.map((date) => {
            custDateStyles.push({
              date: moment(date).utc().valueOf(),
              dots: [
                {
                  color: "red",
                  // selectedColor: <string> (optional),
                },
              ],
            });
          });
          if (custDateStyles.length > 0) {
            setCustomRedDatesStyles(custDateStyles);
          }
        }
      },
      (err) => {
        console.log("err", err);
      }
    );
    db.unsyncedOperations.toArray().then(
      (finished) => {
        // let data = finished[finished.length-1];
        if (finished.length > 0) {
          let dates = [];
          finished.map((entry) => {
            if (entry.VRid == `${vid}-${rid}`) {
              dates.push(new Date(parseInt(entry.UTCtimeStamp)));
              dates = [...new Set(dates)];

              dates.map((date) => {
                custDateStylesBlue.push({
                  date: moment(date).utc().valueOf(),
                  dots: [
                    {
                      color: "rgb(93, 229, 253)",
                      // selectedColor: <string> (optional),
                    },
                  ],
                });
              });
            }
          });

          if (custDateStylesBlue.length > 0) {
            setCustomRedDatesStyles(custDateStylesBlue);
          }
        }
      },
      (err) => {}
    );

    setTimeout(() => {
      if (window.navigator.onLine == false) {
        let dates = [...custDateStylesBlue, ...custDateStyles];
        setCustomDatesStyles(dates);
      }
    }, 1000);

    // }
  };

  const setWeek = (start, end) => {
    debouncedSave([start, end]);
  };

  const datesBlacklistFunc = (date) => {
    return (
      moment(date).startOf("day").valueOf() > moment().startOf("day").valueOf()
    ); // disable Saturdays
  };

  const isValidDate = (d) => {
    return d instanceof Date && !isNaN(d);
  };

  const saveSketch = (data) => {
    setSketch((prevSketch) => {
      const sketches = { ...prevSketch, ...data };
      return sketches;
    });
  };

  const goToDate = (timestamp, error, item) => {
    setPrevData(item);
    setErrorDate(timestamp);
    setSensorError(error);
    setErrorClicked(true);
    const date = new Date(timestamp);
    setPrevDateTime(new Date(timestamp));
    if (moment(date).format("L") == selectedDate) {
      setClickEvent(true);
    }
    if (moment(date).format("L") !== selectedDate) {
      setReloadCalendar(false);
      setSelectedDate(moment(date).format("L"));
      setTimeout(() => {
        setReloadCalendar(true);
      }, 1000);
    }
    setViewWarning(false);
    setPastTime(false);
    // getformData();
  };
  const deleteTime = (timestamp, item) => {
    setPastTime(false);
    confirmDialog({
      message: "Do you want to delete this operation Feed?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: () => acceptDelete(timestamp, item),
      reject: () => setPastTime(true),
    });
  };
  const acceptDelete = (timestamp, item) => {
    if (item.online) {
      setDeleteItem(item);
      db.syncedOperations.toArray().then((data) => {
        data.map((each) => {
          if (each.UTCtimestamp && each.UTCtimestamp == timestamp) {
            let getValueId = each.valueId;
            db.syncedOperations.delete(getValueId);
          }
        });
      });
      db.validationErrors.toArray().then((data) => {
        data.map((each) => {
          if (each.id == vid) {
            if (each.data[rid] && each.data[rid][timestamp]) {
              // Remove the entry for this timestamp
              delete each.data[rid][timestamp];
              // If each.data[rid] is now empty, remove it as well
              if (Object.keys(each.data[rid]).length === 0) {
                delete each.data[rid];
              }
              // Save the updated object back to indexedDB
              db.validationErrors.put(each, each.id);
              setVRErrors(each.data[rid] || {});
              setSensorError({});
            }
          }
        });
      });
      deleteSensorFeedByTime({
        variables: {
          vesselId: +vid,
          roomId: +rid,
          timestamp: timestamp,
          docType: docType,
          correlationId: corelationId ? corelationId : "",
        },
      });
    } else {
      db.unsyncedOperations.delete(item.valueId);
      setTimeList((prev) =>
        prev.filter((entry) => !entry.valueId || entry.time !== item.time)
      );
      setWeek();
      getformData();
      toast.success("Entry deleted successfully");
    }
    setPastTime(false);
  };

  const [deleteSensorFeedByTime, { loading: deleteLoading }] = useMutation(
    DELETE_SENSOR_FEED_BY_TIME,
    {
      fetchPolicy: "network-only",
      onCompleted(resp) {
        toast.success("Entry deleted successfully");
        getformData();
        loadFinishedTimes();
        setWeek();
      },
      onError(err) {
        toast.dismiss();
        toast.error(
          "An error occured while deleting the data. Please try again."
        );
      },
    }
  );

  const onTimeChange = (e) => {
    setErrorDate(null);
    setTimeout(() => {
      setPrevDateTime(new Date(e.value));
    });
  };
  return (
    <div className="sensors-container">
      {timeList && timeList.length > 0 ? (
        <Dialog
          header="Room finished time"
          visible={pastTime}
          style={{ maxWidth: "400px", width: "90%" }}
          onHide={() => setPastTime(false)}
        >
          {timeList.map((item, i) => {
            return (
              <>
                <Row>
                  <Col
                    xs={9}
                    md={9}
                    className="text-left"
                    style={{ display: "flex" }}
                  >
                    <span
                      className={`status-dot ${
                        item.online ? "online-dot" : "offline-dot"
                      }`}
                    ></span>
                    <p className="time-stamp">
                      {moment(parseInt(item.time)).format("MMMM Do, h:mm:ss A")}
                    </p>
                  </Col>
                  <Col xs={2} md={2} className="text-right time_delete">
                    <i
                      className="pi pi-pencil edit_icon"
                      onClick={() => {
                        setErrorClicked(false);
                        setTimeout(() => {
                          goToDate(
                            parseInt(item.time),
                            timeList[item.time],
                            item
                          );
                        });
                      }}
                    ></i>
                  </Col>
                  <Col xs={1} md={1} className="text-right time_delete">
                    <i
                      className="pi pi-trash delete_trash"
                      onClick={() => deleteTime(item.time, item)}
                    ></i>
                  </Col>
                </Row>
                <hr />
              </>
            );
          })}
        </Dialog>
      ) : null}
      {VRErrors && Object.keys(VRErrors).length > 0 ? (
        <Dialog
          header={
            classSociety == "LLOYDS" ? "Lloyds Sync Status" : "BV Sync Status"
          }
          visible={viewWarning}
          style={{ maxWidth: "400px", width: "90%" }}
          onHide={() => setViewWarning(false)}
        >
          <p>
            Below timestamps have data which has an error. Please fix the errors
            and sync again.
          </p>
          {Object.keys(VRErrors).map((time, i) => {
            return (
              <>
                <Row>
                  <Col xs={8} md={8} className="text-left">
                    <p className="time-stamp">
                      {moment(parseInt(time)).format("MMMM Do, h:mm A")}
                    </p>
                  </Col>
                  <Col xs={4} md={4} className="text-right">
                    <Button
                      label="Fix now"
                      className="p-button-warning p-button-text"
                      onClick={() =>
                        goToDate(parseInt(time), VRErrors[time], null)
                      }
                    />
                  </Col>
                </Row>
                <hr />
              </>
            );
          })}
        </Dialog>
      ) : null}

      {uploadInprogress ? (
        <div className="file-loader">
          <i
            className="pi pi-spin pi-spinner"
            style={{ fontSize: "2em", position: "relative", top: "50%" }}
          ></i>
        </div>
      ) : null}
      <div className="header">
        <div className="title">
          <h4 className="welcome">{localStorage.getItem("roomName")}</h4>
          {/* data.componentsVirtualSensorByVesselRoom.map((component, i) => (
          )) */}
          {finishedTime && userName != "" && userName != null ? (
            <p className="finishedUser">
              Room was last finished by {userName} at {finishedTime}
            </p>
          ) : (
            <p className="finishedUser"></p>
          )}
          {finishedTime &&
          finishedTime !== "Invalid date" &&
          (userName == "" || userName == null) ? (
            <p className="finishedUser">Room was finished at {finishedTime}</p>
          ) : (
            <p className="finishedUser"></p>
          )}
          {!finishedTime && !userName ? (
            <p className="finishedUser">Data was not yet entered</p>
          ) : (
            <p className="finishedUser"></p>
          )}
          {finishedTime == "Invalid date" && !userName ? (
            <p className="finishedUser">Data was not yet entered</p>
          ) : (
            <p className="finishedUser"></p>
          )}
        </div>
      </div>
      <div className="overflow">
        {error && <Messages data={error} />}
        {(loading || sensorValueLoading) && (
          <div className="loader">
            <Loader
              type="TailSpin"
              color=" #2546B1"
              height={80}
              width={80}
              timeout={300000000000000}
            />
          </div>
        )}
        {datesLoading && (
          <div className="loader">
            <Loader
              type="TailSpin"
              color=" #2546B1"
              height={80}
              width={80}
              timeout={300000000000000}
            />
          </div>
        )}
        {deleteLoading && (
          <div className="loader">
            <Loader
              type="TailSpin"
              color=" #2546B1"
              height={80}
              width={80}
              timeout={300000000000000}
            />
          </div>
        )}
        {components &&
          components.componentsVirtualSensorByVesselRoom &&
          components.componentsVirtualSensorByVesselRoom.length === 0 && (
            <p>No components to list!</p>
          )}
        <div className={`${showCommentsModal ? "clickedIcon" : ""}`}>
          <div className="tool">
            {!bvRoom ? (
              <span className={`addIcon`}>
                <Icon
                  icon="ion:chatbubbles"
                  className="add-icon"
                  onClick={() =>
                    showCommentsModal ? cancelCommentAdd() : openCommentAdd()
                  }
                />
              </span>
            ) : null}
            {VRErrors && Object.keys(VRErrors).length > 0 ? (
              <img
                className="warning-icon"
                src={warning}
                data-tip
                data-for="validations"
                alt="warning"
                onClick={() => setViewWarning(true)}
              />
            ) : null}
            {timeList.length > 0 && (
              <span className="time-list">
                <i
                  className="pi pi-list list_item"
                  onClick={() => getPastTime()}
                ></i>
              </span>
            )}
            <span data-tip data-for="syncInfo" className="tool-tip">
              i
            </span>
            <ReactTooltip
              id="validations"
              type="dark"
              effect="float"
              className="customeTheme"
            >
              Click to view the validation errors
            </ReactTooltip>
            <ReactTooltip
              id="syncInfo"
              type="dark"
              effect="float"
              className="customeTheme"
            >
              {/* <ul> */}
              {/* <div>
                <div className="dot">
                  <div className="red"></div>
                </div>
                <div className="float-right w-120">Data saved offline</div>
              </div> */}
              <div>
                <div className="dot">
                  <div className="green"></div>
                </div>
                <div className="float-right w-120">Data saved online</div>
              </div>
              <div>
                <div className="dot">
                  <div className="blue"></div>
                </div>
                <div className="float-right w-120">Data not yet saved</div>
              </div>
              <div>
                <div className="dot">
                  <div className="">
                    <span>
                      <img
                        src={approval}
                        alt="Approved"
                        className="approval-info"
                      />
                    </span>
                  </div>
                </div>
                <div className="float-right w-120">Data approved</div>
              </div>
              {/* </ul> */}
            </ReactTooltip>
          </div>
          <View style={styles.container}>
            {reloadCalendar ? (
              <CalendarStrip
                datesBlacklist={datesBlacklist}
                scrollable={false}
                maxDate={calMaxDate}
                // scrollerPaging
                onDateSelected={(v) => {
                  stop = true;
                  setSensorError({});
                  // setErrorClicked(false);
                  setErrorDate(null);
                  selectedDay(v);
                }}
                onWeekChanged={(s, e) => {
                  if (!stop) setWeek(s, e);
                }}
                selectedDate={selectedDate}
                customDatesStyles={customServerStyles}
                daySelectionAnimation={{
                  type: "border",
                  duration: 200,
                  borderWidth: 1,
                  borderHighlightColor: "black",
                }}
                markedDates={customDatesStyles}
                highlightDateNameStyle={{
                  color: "#224691",
                  fontSize: 13,
                }}
                highlightDateNumberStyle={{
                  color: "#224691",
                  fontSize: 17,
                }}
                style={{
                  height: 120,
                  // border: "5px solid #224691",
                  borderRadius: 45,
                  paddingTop: 10,
                  // paddingBottom: 10,
                }}
                // innerStyle={{ height: 150 }}
                calendarColor={"#ffffff"}
                calendarHeaderStyle={{
                  color: "#224691",
                  fontSize: 18,
                  marginBottom: 15,
                }}
                dateNumberStyle={{ color: "#224691", fontSize: 15 }}
                dateNameStyle={{ color: "#224691", fontSize: 11 }}
                // innerStyle={[]}
                useNativeDriver={false}
                iconLeft={leftArrow}
                iconRight={
                  moment(endDate).startOf("day").valueOf() <=
                  moment().startOf("day").valueOf()
                    ? rightArrow
                    : []
                }
              />
            ) : null}

            {!showCommentsModal ? (
              <div>
                <label className="time-label">Choose Timezone:</label>
                <Dropdown
                  value={selectedTZ}
                  onChange={(e) => setSelectedTZ(e.value)}
                  options={timezones}
                  optionLabel="name"
                  placeholder="Select a Timezone"
                  filter
                  filterBy="abbreviation,alternativeName,name"
                  className="timezones"
                />
              </div>
            ) : null}
            {timePicker && !showCommentsModal ? (
              <div>
                <label className="time-label">Choose Time:</label>
                <Calendar
                  timeOnly
                  hourFormat="12"
                  readOnlyInput
                  showSeconds
                  onChange={(e) => onTimeChange(e)}
                  value={prevDateTime}
                  className="timezones"
                  disabled={enableTime}
                  maxDate={new Date()}
                ></Calendar>
              </div>
            ) : null}

               {MRVErrors && Object.keys(MRVErrors).length > 0 ? (
              <div>
                <label className="config-error">
                  {MRVErrors.length} data config errors present in {classSociety === "BV" ? "Bureau Veritas" : classSociety === "LLOYDS" ? "Lloyds" : classSociety}
                </label>&nbsp;
                {!showErrorDetails ? (
                  <i
                    className="pi pi-angle-down config-icon"
                    style={{ fontSize: '1.5rem', float: 'left', cursor: 'pointer' }}
                    onClick={() => setShowErrorDetails(true)}
                  ></i>
                ) : (
                  <i
                    className="pi pi-angle-up config-icon"
                    style={{ fontSize: '1.5rem', float: 'left', cursor: 'pointer' }}
                    onClick={() => setShowErrorDetails(false)}
                  ></i>
                )}
                {showErrorDetails && (
                  <div className="error-details" style={{ marginTop: '0px', padding: '10px', borderRadius: '4px' }}>
                    <ul className="error_text" style={{ margin: 0, fontSize: 13, float: 'left' }}>
                      {Array.isArray(MRVErrors)
                        ? MRVErrors.map((err, idx) => (
                          <li key={idx}>{err}</li>
                          ))
                        : Object.keys(MRVErrors).map((key, idx) => (
                          <li key={idx}>{MRVErrors[key]}</li>
                          ))}
                    </ul>
                  </div>
                )}
              </div>
            ) : null} 


          </View>
        </div>

        <form
          onSubmit={!showCommentsModal && handleSubmit(onSubmit)}
          onKeyDown={(event) => handleKeyDown(event)}
        >
          {components &&
            components.componentsVirtualSensorByVesselRoom &&
            components.componentsVirtualSensorByVesselRoom.map(
              (component, i) => (
                <div
                  key={i}
                  className={`sensor-list ${
                    showCommentsModal ? "disableSensorList" : ""
                  }`}
                >
                  <div className="sensor-container">
                    <div className="sensor-name">{component.name} </div>
                    {!component.image && online && (
                      <div className="d-block cust-loader">
                        <i
                          className="pi pi-spin pi-spinner"
                          style={{ fontSize: "2em", display: "table" }}
                        ></i>
                      </div>
                    )}
                    {/* {!component.image && !online && <img src={defImage} id='def-image' alt="No image" className="comp-image" />} */}
                    {/* {component.image == 'Not Available' && <img src={defImage} id='def-image' alt="No image" className="comp-image" />} */}
                    {component.image && component.image !== "Not Available" && (
                      <img
                        onClick={() => openImageViewer(0, component.image)}
                        src={component.image}
                        id="select-image"
                        alt="component image"
                        className="comp-image"
                      />
                    )}
                    {isViewerOpen && (
                      <ImageViewer
                        src={images}
                        currentIndex={currentImage}
                        disableScroll={false}
                        closeOnClickOutside={true}
                        onClose={closeImageViewer}
                      />
                    )}
                    <div className="sensor-form">
                      {component.Sensor.map((sensor, j) => (
                        <>
                          <InputField
                            key={j}
                            props={props}
                            error={sensorError}
                            inputProps={sensor}
                            params={params}
                            disabled={disableField}
                            style={{ opacity: 0.8 }}
                            setValue={setValue}
                            values={formData}
                            code={component.code}
                            portCodes={portCodes}
                            register={register}
                            control={control}
                            liveData={socketData}
                            componentId={component.id}
                            uploadFiles={uploadFiles}
                            setUploadFiles={setFiles}
                            selectedDate={selectedDate}
                            prevDateTime={prevDateTime}
                            setOffHireHours={setOffHireHours}
                            setValidDeparture={setValidDeparture}
                            setValidArrival={setValidArrival}
                            bvRoom={bvRoom}
                            saveSketch={saveSketch}
                            setFileNames={setFileNames}
                          />
                          {sensor.lastSyncedValue &&
                            sensor.lastSyncedValue !== "null" && (
                              <div className="sensor-latest-details">
                                <i class="pi pi-info-circle sensor-info"></i>
                                Latest received value was{" "}
                                {sensor.lastSyncedValue} on{" "}
                                {sensor.lastSyncedTime}
                              </div>
                            )}
                        </>
                      ))}
                    </div>
                  </div>
                </div>
              )
            )}
          {showCommentsModal ? (
            <>
              <ChatInterface
                vid={vid}
                rid={rid}
                cid={cid}
                selectedDate={selectedDate}
              ></ChatInterface>
            </>
          ) : (
            <p className=""></p>
          )}

          {!showCommentsModal ? (
            <input
              className={`fin-btn${bvRoom ? "bv" : ""}`}
              type="submit"
              value="Finish"
              disabled={disableField || showCommentsModal}
              style={submitBtnStyle}
            />
          ) : (
            <p></p>
          )}
        </form>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
      />
    </div>
  );
};
const submitBtnStyle = {
  position: "fixed",
  bottom: "26pt",
  left: "50%",
  transform: "translate(-50%, 0)",
  backgroundColor: "#FF6302D1",
  width: "107pt",
  height: "49pt",
  border: "none",
  borderRadius: "40px",
  color: "#fff",
  outline: "none",
};

export default VirtualSensor;
